import React from "react";
import { api, formatApiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { StatusBadge } from "@/components/app/ui-bits";
import RecordInspector, { useRecordInspector } from "@/components/app/RecordInspector";
import ProjectRiskIssueChange from "@/components/app/ProjectRiskIssueChange";
import { ShieldWarning, ArrowRight } from "@phosphor-icons/react";
import { PanelHeader, EmptyHint, useFetchList } from "./_shared";

export default function RiskPanel({ project }) {
  const inspector = useRecordInspector();
  const { items, loading, err } = useFetchList(`/risks?project_id=${project.id}`, [project.id]);
  return (
    <div data-testid={`panel-risk-${project.id}`}>
      <PanelHeader
        icon={ShieldWarning} title="Risk Register"
        subtitle="F-PM-25 · risks linked to this project"
        action={<ProjectRiskIssueChange project={project} trigger={<Button size="sm" variant="outline">Manage <ArrowRight size={11} className="ml-1" /></Button>} />}
      />
      {loading && <div className="text-[11px] text-slate-500">Loading…</div>}
      {err && <div className="rounded-md border border-amber-200 bg-amber-50/60 px-2 py-1.5 text-[11px] text-amber-800">{err}</div>}
      {!loading && !err && items.length === 0 && <EmptyHint message="No risks logged yet. Open Manage to add the first risk." />}
      {items.length > 0 && (
        <ul className="space-y-1.5">
          {items.slice(0, 20).map((r) => (
            <li key={r.id}
                onClick={() => inspector.open(r, { title: r.title || r.description || "Risk", subtitle: `${r.severity_band || "—"} · ${r.status || "—"}` })}
                data-testid={`risk-row-${r.id}`}
                className="flex flex-wrap items-center gap-2 rounded-md border border-slate-200 bg-white px-2 py-1.5 text-sm cursor-pointer hover:bg-slate-50">
              <span className="font-mono-alt text-[10px] uppercase tracking-wider text-slate-500 w-16">{r.severity_band || "—"}</span>
              <span className="min-w-0 flex-1 truncate">{r.title || r.description || "Untitled risk"}</span>
              <StatusBadge status={r.status} />
            </li>
          ))}
        </ul>
      )}
      <RecordInspector {...inspector.props} />
    </div>
  );
}
